module.exports = __webpack_public_path__ + "img/female.40b7502f.svg";